module.exports = __webpack_public_path__ + "static/media/18-days-voyage.e3d75b78.jpg";